import { render } from "./BulkActionsBar.vue?vue&type=template&id=55f8bbe5&scoped=true"
import script from "./BulkActionsBar.vue?vue&type=script&lang=js"
export * from "./BulkActionsBar.vue?vue&type=script&lang=js"

import "./BulkActionsBar.vue?vue&type=style&index=0&id=55f8bbe5&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55f8bbe5"]])

export default __exports__